import { render, staticRenderFns } from "./IzinLokasi.vue?vue&type=template&id=16d7c0f3&scoped=true&"
import script from "./IzinLokasi.vue?vue&type=script&lang=js&"
export * from "./IzinLokasi.vue?vue&type=script&lang=js&"
import style0 from "./IzinLokasi.vue?vue&type=style&index=0&id=16d7c0f3&prod&scoped=true&lang=css&"
import style1 from "./Dokumen.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d7c0f3",
  null
  
)

export default component.exports